module.exports = __webpack_public_path__ + "img/gjjkwyh.b4da26ec.jpg";